export default __webpack_public_path__ + "static/media/ukflag.2e39020a.svg";